import { files, generalRef } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadGridData: async ({ commit, rootState }, payload) => {
    commit("setGridDataLoading", true);
    let columns = [];
    if (payload.columnDefs.length > 0) {
      payload.columnDefs.forEach((column) => {
        columns.push(column.field);
      });
    }
    const response = await axios.get(
      `${rootState.axios.API}${payload.endpoint}`,
      {
        params: {
          columns: columns,
        },
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
    commit("setGridData", response.data);
    commit("setGridDataLoading", false);
  },
  async setAGGridActionMenuState({ commit, state }, payload) {
    commit("setAGGridActionMenu", !state.aGGridActionMenu);
    commit("setSelectedRowData", payload);
  },
  async setSelectedRowData({ commit }, payload) {
    commit("setSelectedRowData", payload);
    commit("setGridDataLoading", false);
  },
};
